import React from 'react';

const Night = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 14 14" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Night_a" d="M924.15 331a7.14 7.14 0 1 0 8.85 8.85 6.3 6.3 0 0 1-8.85-8.85" />
    </defs>
    <use fill="currentColor" xlinkHref="#Night_a" transform="translate(-919 -331)" />
  </svg>
);

export default Night;



// WEBPACK FOOTER //
// ./src/common/icons/Night.js